export var LOCATION_TYPES = {
  digital: 'DIGITAL',
  pickupLocations: 'PICK_UP_LOCATIONS',
  pickupPoints: 'PICKUP_POINTS',
  search: 'SEARCH',
  shipping: 'SHIPPING',
  store: 'STORE_VIEWS',
  pickup: 'PICKUP',
  ship: 'SHIP'
};
export var BUY_PARTNER_CART_REVIEWS = 'buy/partner_cart_reviews/v1'; // NOTE: MYBAG-4855 reminder to remove all references partner cart

export var DOTCOM_CHANNEL_ID = 'd9a5bc42-4b9c-4976-858a-f159cf99c647';
export var SNRKS_WEB_CHANNEL_ID = '010794e5-35fe-4e32-aaff-cd2c74f89d61';
export var GRAPHQL_ERROR_CODE = 'GRAPHQL_ERROR';
export var FULFILLMENT_OFFERINGS_SEARCH_RADIUS = 50;
export var GUEST = 'Guest';
export var HOST_NAME = process.env.NEXT_PUBLIC_HOST_NAME;
export var API_HOST_NAME = process.env.NEXT_PUBLIC_API_HOST_NAME;
export var INTERNAL = '__INTERNAL_USE__';